import { render, staticRenderFns } from "./Reels.html?vue&type=template&id=bdb1b572&external"
import script from "./Reels.js?vue&type=script&lang=js&external"
export * from "./Reels.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports